import React, { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { formatDate } from "../../helper/Helper";
import ToggleBtn from "../../components/partials/ToggleBtn";
import { Link } from "react-router-dom";

const SortableRow = React.memo(
  ({
    item,
    index,
    level = 0,
    collapsed,
    toggleCollapse,
    handleStatusChange,
    handleStatus,
    openDelete,
  }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: item._id });

    // Background colors for alternating levels (odd/even)
    const backgroundColors = ["#ffffff", "#f5f5f5", "#bdbdbd", "#e5e5e5"];
    const bgColor = backgroundColors[level % backgroundColors.length];

    // Inline style for dragging state
    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      backgroundColor: isDragging ? "#f7f7f7" : bgColor,
      willChange: transform ? "transform" : "auto",
      zIndex: isDragging ? 1 : "auto",
    };

    return (
      <>
        <tr ref={setNodeRef} style={style}>
          <td
            style={{
              paddingLeft: `${level * 30 + 5}px`, // Indentation based on level
              borderLeft:
                item.status === "active" ? "5px solid green" : undefined,
            }}
          >
            <i
              className="fas fa-arrows-alt text-dark fs-16 lh-1 handle me-2"
              style={{ cursor: "grab" }}
              {...attributes}
              {...listeners}
            ></i>
            <b>{index + 1}.</b>
          </td>

          <td style={{ paddingLeft: `${level * 30}px` }}>
            <div className="d-flex align-items-center">
              {item.children?.length > 0 && (
                <span
                  onClick={() => toggleCollapse(item._id)}
                  style={{
                    cursor: "pointer",
                    marginRight: 6,
                    fontSize: 14,
                    width: 16,
                    display: "inline-block",
                  }}
                >
                  {collapsed[item._id] ? "▶" : "▼"}
                </span>
              )}

              <div className="d-flex align-items-center file-name-icon">
                {item.image && (
                  <a
                    href={item.image}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="avatar avatar-xl border">
                      <img src={item.image} alt="img" />
                    </span>
                  </a>
                )}
                <div className="lh-0 ms-2">
                  <h6 className="fw-medium">{item.name}</h6>
                  <span className="fs--1">{item.slug}</span>
                </div>
              </div>
            </div>
          </td>

          <td>{formatDate(item.createdAt)}</td>
          <td className="action-table-data">
            <div className="edit-delete-action">
              <ToggleBtn
                active={item.showInNavbar}
                onClick={() =>
                  handleStatus("navbar", item._id, !item.showInNavbar)
                }
                activeText="Hide From Navbar"
                inActiveText="Show In Navbar"
              />

              <ToggleBtn
                active={item.showOnHomepage}
                onClick={() =>
                  handleStatus("homepage", item._id, !item.showOnHomepage)
                }
                activeText="Hide From HomePage"
                inActiveText="Show In HomePage"
              />

              <ToggleBtn
                active={item.status === "active"}
                onClick={() =>
                  handleStatusChange(
                    item._id,
                    item.status === "active" ? "inactive" : "active",
                  )
                }
                activeText="Deactivate"
                inActiveText="Activate"
              />

              <Link to={`/category/edit/${item._id}`} className="me-2 p-2">
                <i className="ti ti-pencil" />
              </Link>

              <a
                className="p-2"
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#delete-modal"
                onClick={() => openDelete(item._id)}
              >
                <i className="ti ti-trash" />
              </a>
            </div>
          </td>
        </tr>

        {item.children &&
          item.children.length > 0 &&
          !collapsed[item._id] &&
          item.children.map((child, childIndex) => (
            <SortableRow
              key={child._id}
              item={child}
              index={childIndex}
              level={level + 1}
              collapsed={collapsed} // ✅ IMPORTANT
              toggleCollapse={toggleCollapse}
              handleStatusChange={handleStatusChange}
              handleStatus={handleStatus}
              openDelete={openDelete}
            />
          ))}
      </>
    );
  },
);

export default SortableRow;
